/**
 * 视频答题（vodQuestion）公共工具：题型标签、答案展示
 */
export const TYPE_LABEL = { radio: '单选', checkbox: '多选', input: '填空', textarea: '多行填空', score: '评分' }
export const TYPE_COLOR = { radio: 'blue', checkbox: 'purple', input: 'cyan', textarea: 'geekblue', score: 'orange' }

export function typeLabel(t) {
  return TYPE_LABEL[t] || t
}
export function typeColor(t) {
  return TYPE_COLOR[t] || 'blue'
}

export function parseConfig(v) {
  if (v && typeof v === 'object') return v
  try { return JSON.parse(v || '{}') } catch (e) { return {} }
}

/**
 * 标准答案展示：
 * radio/checkbox 存的是选项ID（顿号分隔），展示为选项内容；input/textarea 展示文本；score 不判分
 */
export function formatAnswer(q) {
  if (!q) return '—'
  if (q.type === 'score') return '—'
  if (!q.standardAnswer) return '—'
  if (q.type === 'radio' || q.type === 'checkbox') {
    const ids = String(q.standardAnswer).split('、').map(s => String(s).trim())
    const parts = []
    ;(q.options || []).forEach(o => {
      if (ids.indexOf(String(o.id)) !== -1) parts.push(o.content)
    })
    return parts.length ? parts.join('；') : q.standardAnswer
  }
  return q.standardAnswer
}
